const state = {
  permissionList: [],

}

const mutations = {
  SET_PERMISSION: (state, list) => {
    state.permissionList=list;
  }

}

const actions = {
  setPermission({ commit }, list) {
    commit('SET_PERMISSION', list)
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js